import React, { useEffect, useState, useContext, useMemo } from 'react';
import {
    Widget,
    Table,
    Col,
    Row,
    Button,
    FormResetButton,
    Form,
    FormInput,
} from '@digital/ui';
import PerfectScrollbar from 'react-perfect-scrollbar';
import moment from 'moment';
import { dateTimeFormat } from '@app/helpers/dateTimeFormats';
import { currencyFormat } from '@app/helpers/numbers';
import { Collapse, Tooltip, Icon } from 'antd';

import {
    ContabilidadeGeralModel,
    viewArquivoAutorizacao,
    downloadArquivoAutorizacao,
    viewArquivoCartaCorrecao,
    downloadArquivoCartaCorrecao,
    viewArquivoComprovanteCancelamento,
    downloadArquivoComprovanteCancelamento
} from '@app/api/ContabilidadeGeral';
import ModalJustificativas from '../Justificativas/modalJustificativas';
import { compareNumber, compareText } from '@app/helpers/comparators';
import ModalJustificativaExclusao from './modalJustificativaExclusao';

export interface propsIntegradosCancelados {
    integradosCancelados: ContabilidadeGeralModel;
}

const IntegradosCancelados = (props: propsIntegradosCancelados) => {

    const { integradosCancelados } = props;
    const { Panel } = Collapse;

    const column = [
        {
            title: 'Número do Fornecedor',
            dataIndex: 'numeroFornecedor',
            width: '7%',
            sorter: (a, b) => compareNumberString(a.numeroFornecedor, b.numeroFornecedor),
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <Form>
                    <Row>
                        <FormInput
                            placeholder="Pesquisar Número do Fornecedor"
                            name="numeroFornecedor"
                            style={{ marginTop: '15px' }}
                            onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                            onPressEnter={() => {
                                if (typeof confirm === 'function') confirm();
                            }}
                        />
                    </Row>
                    <Row>
                        <Col span={6}>
                            <Button
                                type="primary"
                                style={{ marginLeft: '5px' }}
                                onClick={() => {
                                    if (typeof confirm === 'function') confirm();
                                }}
                                icon="commons-search"
                                size="small">
                                Pesquisar
                            </Button>
                        </Col>
                        <Col span={6}>
                            <FormResetButton
                                size="small"
                                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                beforeReset={() => {
                                    if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                }}>
                                Limpar
                            </FormResetButton>
                        </Col>
                    </Row>
                </Form>
            ),
            filterIcon: filtered => {
                const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
            },
            onFilter: (value, record) =>
                record.numeroFornecedor !== undefined &&
                record.numeroFornecedor
                    .toString()
                    .toLowerCase()
                    .includes(value.toLowerCase()),
        },
        {
            title: 'Número do CT',
            dataIndex: 'numeroContrato',
            sorter: (a, b) => compareNumberString(a.numeroContrato, b.numeroContrato),
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <Form>
                    <Row>
                        <FormInput
                            placeholder="Pesquisar Número do Contrato"
                            name="numeroContrato"
                            style={{ marginTop: '15px' }}
                            onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                            onPressEnter={() => {
                                if (typeof confirm === 'function') confirm();
                            }}
                        />
                    </Row>
                    <Row>
                        <Col span={6}>
                            <Button
                                type="primary"
                                style={{ marginLeft: '5px' }}
                                onClick={() => {
                                    if (typeof confirm === 'function') confirm();
                                }}
                                icon="commons-search"
                                size="small">
                                Pesquisar
                            </Button>
                        </Col>
                        <Col span={6}>
                            <FormResetButton
                                size="small"
                                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                beforeReset={() => {
                                    if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                }}>
                                Limpar
                            </FormResetButton>
                        </Col>
                    </Row>
                </Form>
            ),
            filterIcon: filtered => {
                const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
            },
            onFilter: (value, record) =>
                record.numeroContrato !== undefined &&
                record.numeroContrato
                    .toString()
                    .toLowerCase()
                    .includes(value.toLowerCase()),
        },
        {
            title: 'CNPJ',
            dataIndex: 'cnpjFornecedor',
            sorter: (a, b) => compareNumberString(a.cnpjFornecedor, b.cnpjFornecedor),
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <Form>
                    <Row>
                        <FormInput
                            placeholder="Pesquisar CNPJ"
                            name="cnpjFornecedor"
                            style={{ marginTop: '15px' }}
                            onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                            onPressEnter={() => {
                                if (typeof confirm === 'function') confirm();
                            }}
                        />
                    </Row>
                    <Row>
                        <Col span={6}>
                            <Button
                                type="primary"
                                style={{ marginLeft: '5px' }}
                                onClick={() => {
                                    if (typeof confirm === 'function') confirm();
                                }}
                                icon="commons-search"
                                size="small">
                                Pesquisar
                            </Button>
                        </Col>
                        <Col span={6}>
                            <FormResetButton
                                size="small"
                                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                beforeReset={() => {
                                    if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                }}>
                                Limpar
                            </FormResetButton>
                        </Col>
                    </Row>
                </Form>
            ),
            filterIcon: filtered => {
                const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
            },
            onFilter: (value, record) =>
                record.cnpjFornecedor !== undefined &&
                record.cnpjFornecedor
                    .toString()
                    .toLowerCase()
                    .includes(value.toLowerCase()),
        },
        {
            title: 'Razão Social',
            dataIndex: 'razaoSocialFornecedor',
            sorter: (a, b) => compareText(a.razaoSocialFornecedor, b.razaoSocialFornecedor),
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <Form>
                    <Row>
                        <FormInput
                            placeholder="Pesquisar Razão Social"
                            name="razaoSocialFornecedor"
                            style={{ marginTop: '15px' }}
                            onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                            onPressEnter={() => {
                                if (typeof confirm === 'function') confirm();
                            }}
                        />
                    </Row>
                    <Row>
                        <Col span={6}>
                            <Button
                                type="primary"
                                style={{ marginLeft: '5px' }}
                                onClick={() => {
                                    if (typeof confirm === 'function') confirm();
                                }}
                                icon="commons-search"
                                size="small">
                                Pesquisar
                            </Button>
                        </Col>
                        <Col span={6}>
                            <FormResetButton
                                size="small"
                                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                beforeReset={() => {
                                    if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                }}>
                                Limpar
                            </FormResetButton>
                        </Col>
                    </Row>
                </Form>
            ),
            filterIcon: filtered => {
                const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
            },
            onFilter: (value, record) =>
                record.razaoSocialFornecedor !== undefined &&
                record.razaoSocialFornecedor
                    .toString()
                    .toLowerCase()
                    .includes(value.toLowerCase()),
        },
        {
            title: 'Número do Documento TOTVS',
            dataIndex: 'numeroTotvs',
            sorter: (a, b) => compareNumberString(a.numeroTotvs, b.numeroTotvs),
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <Form>
                    <Row>
                        <FormInput
                            placeholder="Pesquisar Número do Documento"
                            name="numeroTotvs"
                            style={{ marginTop: '15px' }}
                            onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                            onPressEnter={() => {
                                if (typeof confirm === 'function') confirm();
                            }}
                        />
                    </Row>
                    <Row>
                        <Col span={6}>
                            <Button
                                type="primary"
                                style={{ marginLeft: '5px' }}
                                onClick={() => {
                                    if (typeof confirm === 'function') confirm();
                                }}
                                icon="commons-search"
                                size="small">
                                Pesquisar
                            </Button>
                        </Col>
                        <Col span={6}>
                            <FormResetButton
                                size="small"
                                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                beforeReset={() => {
                                    if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                }}>
                                Limpar
                            </FormResetButton>
                        </Col>
                    </Row>
                </Form>
            ),
            filterIcon: filtered => {
                const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
            },
            onFilter: (value, record) =>
                record.numeroTotvs !== undefined &&
                record.numeroTotvs
                    .toString()
                    .toLowerCase()
                    .includes(value.toLowerCase()),
        },
        {
            title: 'Tipo',
            dataIndex: 'tipoArquivoAutorizacao',
            width: '5%',
        },
        {
            title: 'Valor',
            dataIndex: 'valorArquivoAutorizacao',
            render: (text, record) => currencyFormat(record.valorArquivoAutorizacao),
            width: '10%'
        },
        {
            title: 'Condição de Pagamento',
            dataIndex: 'condicaoPagamento',
        },
        {
            title: 'Crédito PIS/COFINS',
            dataIndex: 'creditoPisCofins',
            render: (text, record) => record.creditoPisCofins ? 'Sim' : 'Não'
        },
        {
            title: 'Data de Upload pelo Fornecedor',
            dataIndex: 'dataUploadArquivo',
            render: (text, record) => moment(record.dataUploadArquivo).format(dateTimeFormat)
        },
        {
            title: 'Status Contabilidade Geral',
            dataIndex: 'statusContabilidadeGeral'
        },
        {
            title: 'Status Faturamento',
            dataIndex: 'statusFaturamento',
        },
        {
            title: 'Ações',
            render: (text, record) => (
                <>
                    {
                        record.enabled === false &&
                        <ModalJustificativaExclusao justificativa={record.justificativaExclusao} />
                    }
                    {
                        (record.nomeArquivo.slice(-3).toLowerCase() === 'pdf' ?
                            <Tooltip title={"Visualizar Arquivo"}>
                                <Button
                                    onClick={() => {
                                        viewArquivoAutorizacao(record.idArquivoAutorizacao);
                                    }}
                                    icon="files-view_file"
                                    name="btnVisualizarArquivo"
                                />
                            </Tooltip>
                            :
                            <Tooltip title={"Baixar Arquivo"}>
                                <Button
                                    onClick={() => {
                                        downloadArquivoAutorizacao(record.idArquivoAutorizacao, record.nomeArquivo);
                                    }}
                                    icon="ui-download"
                                    name="btnBaixarArquivo"
                                />
                            </Tooltip>
                        )
                    }
                    {
                        record.arquivoCartaCorrecaoId != null &&
                        (
                            record.nomeArquivoCartaCorrecao.slice(-3).toLowerCase() === 'pdf' ?
                                <Tooltip title="Visualizar Carta Correção">
                                    <Button
                                        onClick={async () => {
                                            await viewArquivoCartaCorrecao({
                                                arquivoCartaCorrecaoId: record.arquivoCartaCorrecaoId,
                                                arquivoAutorizacaoId: record.idArquivoAutorizacao,
                                                filename: record.nomeArquivoCartaCorrecao
                                            });
                                        }}
                                        icon="folders-burn_folder"
                                        name="btnBaixarCartaCorrecao"
                                    />
                                </Tooltip>
                                :
                                <Tooltip title={"Baixar Carta Correção"}>
                                    <Button
                                        onClick={async () => {
                                            await downloadArquivoCartaCorrecao({
                                                arquivoCartaCorrecaoId: record.arquivoCartaCorrecaoId,
                                                arquivoAutorizacaoId: record.idArquivoAutorizacao,
                                                filename: record.nomeArquivoCartaCorrecao
                                            });
                                        }}
                                        icon="folders-delete_folder"
                                        name="btnBaixarCartaCorrecao"
                                    />
                                </Tooltip>
                        )
                    }
                    {
                        record.arquivoComprovanteCancelamentoId != null &&
                        (
                            record.nomeArquivoComprovanteCancelamento.slice(-3).toLowerCase() === 'pdf' ?
                                <Tooltip title="Visualizar Comprovante Cancelamento">
                                    <Button
                                        onClick={async () => {
                                            await viewArquivoComprovanteCancelamento({
                                                arquivoComprovanteCancelamentoId: record.arquivoComprovanteCancelamentoId,
                                                arquivoAutorizacaoId: record.idArquivoAutorizacao,
                                                filename: record.nomeArquivoComprovanteCancelamento
                                            });
                                        }}
                                        icon="folders-delete_folder"
                                        name="btnBaixarComprovanteCancelamento"
                                    />
                                </Tooltip>
                                :
                                <Tooltip title={"Baixar Comprovante Cancelamento"}>
                                    <Button
                                        onClick={async () => {
                                            await downloadArquivoComprovanteCancelamento({
                                                arquivoComprovanteCancelamentoId: record.arquivoComprovanteCancelamentoId,
                                                arquivoAutorizacaoId: record.idArquivoAutorizacao,
                                                filename: record.nomeArquivoComprovanteCancelamento
                                            });
                                        }}
                                        icon="folders-downloads_folder"
                                        name="btnBaixarComprovanteCancelamento"
                                    />
                                </Tooltip>
                        )
                    }
                    {
                        (
                            <ModalJustificativas arquivoAutorizacaoId={record.idArquivoAutorizacao} contemComentario={(record.comentarios > 0)} />
                        )
                    }
                </>
            )
        },
    ];


    return (
        <>
            <Collapse bordered={false} expandIcon={() => <Icon type="arrows-right_4" />}>
                <Panel
                    key='integrados'
                    header={'Integrados'}
                >
                    <Widget>
                        <Row>
                            <Col>
                                <Table columns={column} dataSource={integradosCancelados.contabilidadeIntegrados || []} />
                            </Col>
                        </Row>
                    </Widget>
                </Panel>
            </Collapse>

            <Collapse bordered={false} expandIcon={() => <Icon type="arrows-right_4" />}>
                <Panel
                    key='cancelados'
                    header={'Cancelados'}
                >
                    <Widget>
                        <Row>
                            <Col>
                                <Table columns={column} dataSource={integradosCancelados.contabilidadeCancelados || []} />
                            </Col>
                        </Row>
                    </Widget>
                </Panel>
            </Collapse>

            <Collapse bordered={false} expandIcon={() => <Icon type="arrows-right_4" />}>
                <Panel
                    key='excluidos'
                    header={'Excluídos'}
                >
                    <Widget>
                        <Row>
                            <Col>
                                <Table columns={column} dataSource={integradosCancelados.contabilidadeExcluidos || []} />
                            </Col>
                        </Row>
                    </Widget>
                </Panel>
            </Collapse>
        </>
    );
};

export default IntegradosCancelados;